<template>
  <div class="actions-container flex-this">
    <template v-if="currentTab === 'programme_competencies'">
      <k-text-search v-model="searchText" inputStyle="alt"></k-text-search>
      <k-filters
        ref="filters"
        :filter-options="categoryFilterOptions"
        @filter="handleCategoryFilterUpdate"
      />
      <k-dropdown
        :options="sortModeOptions"
        :model-value="sortMode"
        :show-search="false"
        placeholder="Sort"
        @update:model-value="$emit('changeSortMode', $event)"
      />
    </template>
    <button
      v-if="currentTab !== 'programme_competencies'"
      class="btn btn-outlined"
      @click="$emit('toggleSort')"
    >
      Sort <i class="fas" :class="sortDescending ? 'fa-sort-amount-up' : 'fa-sort-amount-down-alt'" aria-hidden="true"></i>
    </button>
    <button v-if="showLayoutToggle" class="btn btn-outlined" aria-label="Toggle layout" title="Toggle layout" @click="$emit('toggleLayout')">
      <i class="fa-solid" :class="setModulesLayout ? 'fa-list' : 'fa-grid-2'" aria-hidden="true"></i>
    </button>
  </div>
</template>

<style scoped>
.actions-container {
  gap: 10px;
  align-items: center;
}

.actions-container :deep(.k-search-dropdown-button.btn-outlined) {
  padding: 8px 15px;
  width: auto;
}
</style>

<script>
import KTextSearch from '@base-components/k-text-search.vue';
import KFilters from '@base-components/k-filters.vue';
import KDropdown from '@base-components/k-dropdown.vue';
import { COMPETENCY_SORT_MODES } from '@utils/competency-list';

export default {
  components: {
    KTextSearch,
    KFilters,
    KDropdown,
  },

  props: {
    currentTab: {
      type: String,
      default: 'programme_curriculum',
    },
    sortDescending: {
      type: Boolean,
      default: false,
    },
    sortMode: {
      type: String,
      default: COMPETENCY_SORT_MODES.DEFAULT,
    },
    setModulesLayout: {
      type: Boolean,
      default: false,
    },
    showLayoutToggle: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      searchText: '',
      categoryFilterOptions: [
        {
          key: 'Knowledge',
          text: 'Knowledge (K)',
          func: item => item.category === 'Knowledge',
        },
        {
          key: 'Skill',
          text: 'Skills (S)',
          func: item => item.category === 'Skill',
        },
        {
          key: 'Behaviour',
          text: 'Behaviour (B)',
          func: item => item.category === 'Behaviour',
        },
      ],
      // Default when no filters are selected, all items are shown
      combinedCategoryFilterFunction: () => true,
      sortModeOptions: [
        { id: COMPETENCY_SORT_MODES.DEFAULT, name: 'Default order' },
        { id: COMPETENCY_SORT_MODES.WEAKEST, name: 'Weakest first' },
        { id: COMPETENCY_SORT_MODES.STRONGEST, name: 'Strongest first' },
      ],
    };
  },

  watch: {
    searchText() {
      this.emitSearchAndCategoryFilterOptions();
    },
  },

  methods: {
    handleCategoryFilterUpdate(activeFilters) {
      // Combine the category filters into a single filter function using OR logic
      this.combinedCategoryFilterFunction = item => {
        if (activeFilters.length === 0) {
          return true;
        }
        return activeFilters.some(filter => filter.func(item));
      };

      this.emitSearchAndCategoryFilterOptions();
    },

    emitSearchAndCategoryFilterOptions() {
      this.$emit('filter', {
        text: this.searchText,
        categoryFilter: this.combinedCategoryFilterFunction,
      });
    },
  },
};
</script>
